export const FETCH_COUNTRIES = 'APP/FETCH_COUNTRIES/REQUEST';
export const FETCH_COUNTRIES_SUCCESS = 'APP/FETCH_COUNTRIES/SUCCESS';
export const FETCH_COUNTRIES_FAILURE = 'APP/FETCH_COUNTRIES/FAILURE';
